// frontend/src/routes/AppRoutes.tsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LandingPage } from '../pages/LandingPage';
import { DynamicLoginPage } from '../pages/DynamicLoginPage';
import { DashboardPage } from '../pages/DashboardPage';
import { MapPage } from '../pages/MapPage';
import { NotFoundPage } from '../pages/NotFoundPage';
import { ProtectedRoute } from './ProtectedRoutes';
import { CombinedDashboardPage } from '../pages/CombinedDashboardPage';
import { isCombinedProject } from '../core/types/tenant.types';
import { tenantResolver } from '../core/tenant/TenantResolver';
//import HeatmapPage from '../pages/HeatmapPage';

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* In your router */}
      {/* PUBLIC ROUTES */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<DynamicLoginPage />} />
      
      {/* PROTECTED ROUTES */}
  <Route 
  path="/dashboard" 
  element={
    <ProtectedRoute>
      {isCombinedProject(tenantResolver.getCurrentTenant()) ? (
        <CombinedDashboardPage />
      ) : (
        <DashboardPage />
      )}
    </ProtectedRoute>
  } 
/>
      
      <Route 
        path="/map" 
        element={
          <ProtectedRoute>
            <MapPage />
          </ProtectedRoute>
        } 
      />
      
      {/* 404 NOT FOUND */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};